import Vue from 'vue';
import Vue2Filters from 'vue2-filters'
import moment from 'moment'

var Vue2FiltersConfig = {
  currency: {
    symbol: 'R$',
    decimalDigits: 2,
    thousandsSeparator: '.',
    decimalSeparator: ',',
    spaceBetweenAmountAndSymbol: true,
    symbolOnLeft: false
  },
};
Vue.use(Vue2Filters, Vue2FiltersConfig)

Vue.filter('orderBy', function (array, sortBy) {
  if (array == null || array == undefined)
    return array;
  if (array) {
    return _.orderBy(array, sortBy);
  }
});

Vue.filter('addDay', function (value, number) {
  if (value == null || value == undefined)
    return value;
  if (value) {
    let dayAdd = value.setDate(value.getDate() + number);
    let dayDate = new Date(dayAdd);
    return dayDate.toJSON();
  }
});

Vue.filter('addMonth', function (value, number) {
  if (value == null || value == undefined)
    return value;
  if (value) {
    let monthAdd = value.setMonth(value.getMonth() + number);
    let monthDate = new Date(monthAdd);
    return monthDate.toJSON();
  }
});

Vue.filter('firstDayOfMonth', function (value, format = 'DD/MM/YYYY') {
  if (value == null || value == undefined)
    return value;
  if (value) {
    let date = new Date(value.getUTCFullYear(), value.getUTCMonth(), 1);
    return moment(date).format(format);
  }
});

Vue.filter('lastDayOfMonth', function (value, format = 'DD/MM/YYYY') {
  if (value == null || value == undefined)
    return value;
  if (value) {
    let date = new Date(value.getUTCFullYear(), value.getUTCMonth() + 1, 0);
    return moment(date).format(format);
  }
});

Vue.filter('date', function (value, format = 'DD/MM/YYYY') {
  if (value == null || value == undefined)
    return value;
  if (value) {
    return moment(value).format(format)
  }
});

Vue.filter('monthYear', function (value) {
  if (value == null || value == undefined)
    return value;
  if (value) {
    let date = new Date(value);
    return date.getMonthName() + `/${date.getFullYear()} `;
  }
});

Vue.filter('lower', function (value) {
  if (value == null || value == undefined || value.length == 0)
    return value;
  return value.toLowerCase();
});

Vue.filter('upper', function (value) {
  if (value == null || value == undefined || value.length == 0)
    return value;
  return value.toUpperCase();
});

Vue.filter('capitalizeFirstLetter', function (value) {
  if (value == null || value == undefined || value.length == 0)
    return value;
  value = value.toLowerCase();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('capitalizeWords', function (value) {
  if (value == null || value == undefined || value.length == 0)
    return value;
  return value.replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase(); });
});

Vue.filter('substring', function (value, length) {
  if (value == null || value == undefined || value.length == 0 || value.length < (length - 1))
    return value;
  return value.substring(0, length - 1);
});

Vue.filter('identity', function (value) {
  {
    if (value == null || value == undefined || value == '')
      return value;
    let identity = value.replace(/[^\d]/g, "");
    if (identity.length == 11)
      return identity.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    if (identity.length == 14)
      return identity.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    return identity;
  }
});

Vue.filter('phone', function (value, onlyNumber = false) {
  {
    if (value == null || value == undefined || value == '')
      return value;
    var phone = value.replace(/[^\d]/g, "")
    if (onlyNumber)
      return phone;
    if (phone.length == 8) {
      phone = phone.replace(/(\d{4})(\d{4})/, "$1-$2");
    } else if (phone.length == 9) {
      phone = phone.replace(/(\d{5})(\d{4})/, "$1-$2");
    }
    else if (phone.length == 10) {
      phone = phone.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
    }
    else if (phone.length == 11) {
      phone = phone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    }
    return phone;
  }
});

Vue.filter('breakline', function (value) {
  if (value == null || value == undefined || value.length == 0)
    return value;
  return value.replace(/(?:\r\n|\r|\n)/g, '<br/>');
});

var numeral = require("numeral");
Vue.filter("number", function (value) {
  if (value == null || value == undefined)
    return value;
  return numeral(value).format("0,0").replace(',', '.');
});

Vue.filter("regexNumber", function (value) {
  if (value == null || value == undefined)
    return value;
  return value.replace(/[^\d]/g, "");
});

Vue.filter("percentage", function (value) {
  if (value == null || value == undefined || value.length == 0)
    return value;
  let valueFloat = parseFloat(value);
  return valueFloat.toFixed(2).concat('%').replace('.', ',');
});

Vue.filter("toCurrency", function (value) {
  if (value == null || value == undefined || value.length == 0)
    return `R$ ${value}`;
  const valueFloat = parseFloat(value).toFixed(2);
  return `R$ ${valueFloat.replace('.', ',')}`
});

Vue.filter('showValidateError', function (showError, invalid) {
  if (invalid && showError) {
    return 'is-invalid';
  }
  return '';
});



// WEBPACK FOOTER //
// ./src/utils/filters.js